import { render } from "lit-html";
import { FormField } from "../zhi-form-field/zhi-form-field";

class ZhiTextarea extends FormField {
  async renderComponent() {
    const { textareaTemplate } = await import("./zhi-textarea.template");
    render(textareaTemplate({ component: this }), this);
  }
}

customElements.define("zhi-textarea", ZhiTextarea);